import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import { Provider } from 'react-redux';
import Router from './app/router/router';
import { store, persistor } from './app/store';
import { PersistGate } from 'redux-persist/integration/react';
import './app/assets/fonts/icon/style.css';
import { ToastContainer } from 'react-toastify';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ToastContainer />
      <Router />
    </PersistGate>
  </Provider >
  , document.getElementById('root')
);